import { render, staticRenderFns } from "./AModal-contacto.vue?vue&type=template&id=95151aba"
import script from "./AModal-contacto.vue?vue&type=script&lang=js"
export * from "./AModal-contacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports